import {
  ShieldCheck, Car, HardHat, Users, Flame, UserCheck, ShoppingBag,
  Building2, HeartPulse, Briefcase, Siren, Compass, Shield,
} from "lucide-react";

const MAP = {
  ShieldCheck, Car, HardHat, Users, Flame, UserCheck, ShoppingBag,
  Building2, HeartPulse, Briefcase, Siren, Compass,
};

export const ServiceIcon = ({ name, className = "w-6 h-6" }) => {
  const Icon = MAP[name] || Shield;
  return <Icon className={className} aria-hidden="true" />;
};
